<template>
  <div id="app">
<!--    <vue-progress-bar></vue-progress-bar>-->
    <Loading></Loading>
    <div class="top">
      <TTopBar></TTopBar>
    </div>
    <main>
      <TSideBar></TSideBar>
      <div class="router">
        <div class="router-view">
          <router-view/>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import TSideBar from '@/components/TSidebar.vue';
import TTopBar from '@/components/TTopBar.vue';
import axios from 'axios';
import { print } from 'graphql';
import gql from 'graphql-tag';
import Loading from '@/views/Loading.vue';

export default {
  components: {
    Loading,
    TTopBar,
    TSideBar,
  },
  mounted() {
    this.load();
    // this.$Progress.finish();
    // setTimeout(() => {
    //   document.querySelector('.loading').classList.add('hide');
    // }, 1000);
  },
  created() {
    // //  [App.vue specific] When App.vue is first loaded start the progress bar
    // this.$Progress.start();
    // //  hook the progress bar to start before we move router-view
    // this.$router.beforeEach((to, from, next) => {
    //   //  does the page we want to go to have a meta.progress object
    //   if (to.meta.progress !== undefined) {
    //     const meta = to.meta.progress;
    //     // parse meta tags
    //     this.$Progress.parseMeta(meta);
    //   }
    //   //  start the progress bar
    //   this.$Progress.start();
    //   //  continue to next page
    //   next();
    // });
    // //  hook the progress bar to finish after we've finished moving router-view
    // this.$router.afterEach(() => {
    //   //  finish the progress bar
    //   this.$Progress.finish();
    // });
  },
  methods: {
    load() {
      axios({
        url: 'https://theia.informatik.hs-augsburg.de:3030/graphql',
        method: 'post',
        data: {
          query: print(
            gql`query {
              exhibitions {
                id: _id
                name
                start
                end
                rooms
                location
              }
            }
            `,
          ),
        },
        headers: {
          theia: '83UcD&mA%Sr&%q',
        },
      })
        .then((result) => {
          this.$store.state.exhibitions = [];
          result.data.data.exhibitions.forEach((exhibition) => {
            const convertedResult = {
              id: exhibition.id,
              name: exhibition.name,
              start: this.parseISOString(exhibition.start),
              end: this.parseISOString(exhibition.end),
              rooms: exhibition.rooms,
              location: exhibition.location,
            };
            this.$store.state.exhibitions.push(convertedResult);
            this.$store.state.exhibitionsLoaded = true;
          });
          console.log('Loaded exhibitions');
          document.getElementById('loading').classList.add('hide');
        });
    },
    parseISOString(s) {
      const b = s.split(/\D+/);
      return new Date(Date.UTC(b[0], b[1] - 1, b[2], b[3], b[4], b[5], b[6]));
    },
  },
};
</script>

<style lang="scss">

  @import 'assets/scss/reset';
  @import 'assets/scss/theme';
  @import 'assets/scss/global.scss';

  body {
    font-family: "Hind Madurai", sans-serif;
    box-sizing: border-box;
  }

  #app {
    font-family: "Hind Madurai", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $dark100;
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
  }

  * {
    transition: .1s all ease-in-out;
  }

  *:focus {
    outline: none;
  }

  main {
    display: flex;
    flex-grow: 1;

    @media (max-width: 1199.98px) {
      flex-direction: column;
    }

    .router {
      width: 100%;
      background: $dark5;

      @media (max-width: 1199.98px) {
        flex-grow: 1;
      }

      .router-view {
        padding: 0 2rem;
      }
    }
  }
</style>
